import { Panel, Skeleton } from '@cast/design-system';

export const ResourcePanelSkeleton = () => (
  <Panel sx={{ p: 16, height: '100%' }}>
    <Skeleton variant="rounded" height={148} sx={{ width: '100%' }} />
  </Panel>
);
